
define('text!modules/T1App/myApps/templates/myApps.html',[],function () { return '<div class="t1-apps-container"></div>\n';});

